import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GridService } from '../shared/grid/grid.service';
import { ToastService } from './toast.service';
import { Email, SendEmailRequest } from '../models/email.model';

@Injectable({
    providedIn: 'root'
})
export class EmailService extends GridService<Email> {

    constructor(
        http: HttpClient,
        private toastService: ToastService
    ) {
        super('Email', http);
    }

    sendEmail(payload: SendEmailRequest): Observable<Email> {
        return this.http.post<Email>(
            this.getApiUrl('Email/SendToEmployee'),
            payload
        ).pipe(
            map(response => {
                this.toastService.showSuccess('Email sent successfully', true);
                return response;
            }),
            catchError(error => {
                const errorMessage = error?.error?.message || error?.message || 'Failed to send email';
                this.toastService.displayErrorMessage(errorMessage, true);
                throw error;
            })
        );
    }
}